export const IdentityStatusLabels: Record<string, string> = {
  OK: "ins_check_ok",
  KO: "ins_check_ko",
  "00": "00 - Une identité trouvée",
  "01": "01 - Aucune identité trouvée",
  "02": "02 - Plusieurs identités trouvées",
};
